import * as React from "react"

export default function FollowUserSolidIcon(props) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.665 11.875v6.457H3.332a6.667 6.667 0 018.333-6.457zM10 10.832c-2.763 0-5-2.237-5-5 0-2.762 2.237-5 5-5 2.762 0 5 2.238 5 5 0 2.763-2.238 5-5 5zm5 3.333v-2.5h1.666v2.5h2.5v1.667h-2.5v2.5H15v-2.5h-2.5v-1.667h2.5z"
        fill={props.fill}
      />
    </svg>
  )
}
